import { Settings2FAContext } from "../types/Settings2FAContext";
import { Settings2FAEvent } from "../types/Settings2FAEvent";

export const setSecretAction = (
  _context: Settings2FAContext,
  event: Settings2FAEvent
): Partial<Settings2FAContext> => {
  if (event.type !== "SECRET_FETCHED") {
    throw new Error("Invalid event type");
  }
  return {
    qrCodeUrl: event.qrCodeUrl,
  };
};
